import { useState } from 'react'

import { Heading, theme } from '@hhgtech/hhg-components'
import { Button, Text } from '@hhgtech/hhg-components/mantine'
import { List, Stack, StackProps } from '@mantine/core'
import { useIntl } from 'react-intl'

import { assetImagePath } from 'interfaces/constants'
import { useExpertStore } from 'state/expert'

type _EducationProps = StackProps

export const _Education = ({ ...rest }: _EducationProps) => {
  const { formatMessage: f } = useIntl()
  const [showAllEducation, setShowAllEducation] = useState(true)
  const { currentExpert: expert } = useExpertStore((state) => ({
    currentExpert: state.currentExpert,
  }))
  return (
    <>
      {expert?.fields?.educations &&
        Array.isArray(expert?.fields?.educations) &&
        expert?.fields?.educations.length > 0 && (
          <Stack spacing={16} {...rest}>
            <Text weight="bold" size="c2" color={theme.colors.gray400}>
              {f({
                id: 'expert.content.education',
                defaultMessage: 'Education',
              }).toUpperCase()}
            </Text>

            <List
              styles={{
                itemIcon: {
                  marginRight: 0,
                },
              }}
              spacing={12}
              icon={
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="2" fill="#2D87F3" />
                </svg>
              }
            >
              {(showAllEducation
                ? expert?.fields?.educations
                : expert?.fields?.educations.slice(0, 3)
              ).map((education, index) => (
                <List.Item key={`item-${index}`}>
                  <Stack spacing={0}>
                    <Heading tag="h6" color={theme.colors.gray800}>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: education.study,
                        }}
                      />
                    </Heading>
                    <Text size="p3" color={theme.colors.gray500}>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: education?.school_name || '',
                        }}
                      ></span>
                    </Text>
                  </Stack>
                </List.Item>
              ))}
            </List>
            {expert?.fields?.educations.length > 3 && !showAllEducation && (
              <Button
                variant="ghost"
                compact
                size="sm"
                w="fit-content"
                onClick={() => setShowAllEducation(true)}
                rightIcon={
                  <img
                    src={`${assetImagePath}/chevronDownBlue.svg`}
                    alt="see-more"
                    loading="lazy"
                  />
                }
              >
                {f({
                  id: 'expert.content.seeMore',
                  defaultMessage: 'See more',
                })}
              </Button>
            )}
          </Stack>
        )}
    </>
  )
}
